import React from 'react';
import { compose } from 'redux';
import { CampaignsState, withCampaigns } from '@domain/campaigns';
import { isDataLoading } from '@shared/axios';
import { withComparisonCampaigns } from '@domain/comparison-campaigns';
import {
    insertComparisonColumns,
} from '@domain/campaigns/campaign-table/campaign-table-comparison-columns.utils';
import { DashboardFiltersProps, withDashboardFilters } from '@domain/dashboard/dashboard-filters';
import {
    FIXED_COLUMNS_CAMPAIGN_TABLE,
} from '@domain/campaigns/campaign-table/campaign-table-metrics.constants';
import { PROJECTION_METRICS } from '@shared/tables';
import {
    CAMPAIGN_TABLE_APPCUES_ID,
    CAMPAIGN_TABLE_HEADER_TEXTS,
} from '@domain/campaigns/campaign-table/campaign-table-header/campaign-table-header.constants';
import { MetricsReportTable } from '@domain/advertising/tables/metrics-report-table/metrics-report-table';

interface CampaignTableProps {
    filteredCampaigns: CampaignsState;
    comparisonCampaigns: CampaignsState;
    dashboardFilters: DashboardFiltersProps;
}

const CampaignTableImpl = ({
    filteredCampaigns,
    comparisonCampaigns,
    dashboardFilters,
}: CampaignTableProps) => {
    const { ranges } = dashboardFilters;

    const isLoading = isDataLoading(filteredCampaigns.loadState);

    const campaignsData = Object.values(filteredCampaigns.data);

    const data = ranges?.comparisonDate
        ? insertComparisonColumns(campaignsData, comparisonCampaigns.data)
        : campaignsData;

    const headerProps = {
        advancedMetrics: PROJECTION_METRICS,
        headerTexts: CAMPAIGN_TABLE_HEADER_TEXTS,
        dataAppcuesIds: CAMPAIGN_TABLE_APPCUES_ID,
    };

    return (
        <MetricsReportTable
            data={data}
            isLoading={isLoading}
            additionalColumns={FIXED_COLUMNS_CAMPAIGN_TABLE}
            headerProps={headerProps}
        />
    );
};

export const CampaignTable = compose(
    withCampaigns,
    withComparisonCampaigns,
    withDashboardFilters,
)(CampaignTableImpl);
